// Utility function to ensure all cases are handled
export function assertNever(x) {
    throw new Error(`Unhandled case: ${x}`);
}
